import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Home from './pages/Home';
import ArtistList from './pages/ArtistList';
import ArtistProfile from './pages/ArtistProfile';
import EventDetail from './pages/EventDetail';
import Dashboard from './pages/Dashboard';
import BookingDetail from './pages/BookingDetail';
import Messages from './pages/Messages';
import HowItWorks from './pages/HowItWorks';

function App() {
  return (
    <Routes>
      {/* Pages auth — sans Layout (plein écran) */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />

      {/* Pages avec Layout (Header + Footer) */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/artists" element={<ArtistList />} />
        <Route path="/comment-ca-marche" element={<HowItWorks />} />
        <Route path="/artists/:slug" element={<ArtistProfile />} />
        <Route path="/events/:slug" element={<EventDetail />} />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <Messages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bookings/:id"
          element={
            <ProtectedRoute>
              <BookingDetail />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
